export function capitalizeWords (str) {
  return str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

export function filterByDate (data = [], startDate) {
  return data.filter(item => {
    const itemDate = new Date(item.scrapeDate);
    return itemDate >= new Date(startDate);
  });
}

export function isInWeeklySequence (baseDate, targetDate) {
  // Set to start of day to ignore time
  const base = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());
  const target = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate());
  // Calculate days difference
  const diffDays = Math.round((target - base) / (1000 * 60 * 60 * 24));

  // Must be exact multiple of 7 days difference
  return diffDays % 7 === 0 && diffDays >= 0;
}

export function isMonthlySequence (baseDate, targetDate) {
  // Set to start of day to ignore time
  const base = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());
  const target = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate());

  // Check if it's the same day of the month and not before the base date
  return base.getDate() === target.getDate() && target >= base;
}

export function formatDate (d = new Date()) {
  const month = (+d.getMonth() + 1) < 10 ? `0${d.getMonth() + 1}` : d.getMonth() + 1;
  const date = +d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();
  return `${month}/${date}/${d.getFullYear()}`;
}